(function () {
  'use strict';

  angular.module('app').service('BookingItemServiceItemService', BookingItemServiceItemService);

  BookingItemServiceItemService.$inject = ['BookingItemServiceItemModalService'];

  function BookingItemServiceItemService(BookingItemServiceItemModalService) {
    let service = {
      openBookingItemServiceItemStandardCostBased: openBookingItemServiceItemStandardCostBased,
    };

    return service;

    ///////////////

    function openBookingItemServiceItemStandardCostBased(
      bookingItemServiceItem,
      bookingItem,
      booking,
      documentDateExchangeRate,
      successCallback
    ) {
      BookingItemServiceItemModalService.openBookingItemServiceItemStandardCostBased(
        bookingItemServiceItem,
        bookingItem,
        booking,
        documentDateExchangeRate,
        successCallback
      );
    }
  }
})();
